import { IAnalyticsRepository, IAnalyticsRepositoryParams, IDeductionsByPurchaserRepositoryResponse } from "@/core/repositories/analytics";

export class GetDeductionsByPurchaserUseCase {
  constructor(private readonly repo: IAnalyticsRepository) {}

  async execute(params: IAnalyticsRepositoryParams): Promise<IDeductionsByPurchaserRepositoryResponse> {
    return this.repo.getDeductionsByPurchaser(params);
  }
}
